import { createFileRoute, redirect } from '@tanstack/react-router';
import verificationStatus from 'data/verificationStatus';
import { VerificationTierStatus } from 'services/generated';
import { verificationApi } from 'store/slices/verification-api';
import { preloadQueries } from 'utils/preloading';
import { steps } from './steps';

export const Route = createFileRoute('/_authenticated/verification/')({
  beforeLoad: async ({ location }) => {
    const [res] = await preloadQueries(
      verificationApi.endpoints.getVerificationStatus.initiate(),
    );

    const lastCompletedStepNumber = getLastCompletedStepNumber(res.data!);
    const nextStep = steps.find(
      s => s.stepNumber == lastCompletedStepNumber + 1,
    );

    if (nextStep) {
      const stepUrl = `/verification/${nextStep.link}`;
      if (location.pathname != stepUrl) {
        throw redirect({ to: stepUrl });
      }
    } else {
      throw redirect({ to: '/products' });
    }
  },
});

function getLastCompletedStepNumber(status: VerificationTierStatus) {
  const { started, completed, actions } = status;

  if (!actions) return 1;

  const finished = !(
    actions.filter(x => x.statusCode !== verificationStatus.Verified).length > 0
  );

  let returnValue = 1;

  if (started) returnValue = 2;
  if (
    actions.find(
      x =>
        x.actionCode === 'USE' &&
        x.completed &&
        x.statusCode === verificationStatus.Verified,
    )
  )
    returnValue = 2;
  if (
    actions.find(
      x =>
        x.actionCode === 'ZAR_INV_30' &&
        x.completed &&
        x.statusCode === verificationStatus.Verified,
    )
  )
    returnValue = 2;
  if (
    actions.find(
      x =>
        x.actionCode === 'ZAR_INV_365' &&
        x.completed &&
        x.statusCode === verificationStatus.Verified,
    )
  )
    returnValue = 3;
  if (
    actions.find(
      x =>
        x.actionCode === 'EMPLOYMENT' &&
        x.completed &&
        x.statusCode === verificationStatus.Verified,
    )
  )
    returnValue = 4;
  if (
    actions.find(
      x =>
        x.actionCode === 'LEVEL' &&
        x.completed &&
        x.statusCode === verificationStatus.Verified,
    )
  )
    returnValue = 4;

  if (
    actions.find(
      x =>
        x.actionCode === 'SOURCE' &&
        x.completed &&
        x.statusCode === verificationStatus.Verified,
    )
  ) {
    returnValue = 4;
  }
  if (
    actions.find(
      x => x.actionCode === 'ID' && x.statusCode === verificationStatus.Started,
    )
  )
    returnValue = 5;
  if (
    actions.find(
      x =>
        x.actionCode === 'ID' &&
        [
          verificationStatus.Verified,
          verificationStatus.PendingAdmin,
          verificationStatus.PendingProvider,
        ].includes(x.statusCode),
    )
  ) {
    returnValue = 6;
  }

  if (finished && completed) returnValue = 7;

  return returnValue;
}
